<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'common.related-info'">_Información relacionada</span>
  </div>
  <!-- Contenedor -->
   <div class="related-information-modal__container-header-breadcrumb">
    <i class="lf-icon-map-marker common-icon__md"></i>
    <div class="related-information-modal__text-header-breadcrumb">{{relatedInformationModal.conceptName}}</div>
    <!-- @for (breadcrumb of relatedInformationModal.relatedModalList[0].route; track $index) {
      <div class="related-information-modal__text-header-breadcrumb">
          @if (!$first) {
            <span> > </span>
          }
          <span-tooltip [text]="breadcrumb.name"></span-tooltip>
      </div>
    } -->
   </div>
  <div class="related-information-modal__container-info">
    <!-- <div class="related-information-modal__container-inner-info"> -->
    @if (relatedInformationModal.infoRelatedSelected?.label) {
      <div class="related-information-modal__container-header-info">{{relatedInformationModal.infoRelatedSelected?.label}}</div>
    }
    <div class="related-information-modal__container-body-info"
      [innerHTML]="relatedInformationModal.description"></div>
    <!-- </div> -->
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-noborder"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar</span>
    </button>
    @if (relatedInformationModal.infoRelatedSelected?.frontIds?.conceptObjectId) {
      <button class="common-button__text-border"
        (click)="openNewWindow()">
        <span class="common-button__text-title flex gap-[3px]">
          <span [afTranslate]="'related-information-modal.view-in'">_Ver en </span><span>{{relatedInformationModal.infoRelatedSelected?.evaluationName}}</span>
        </span>
      </button>
    }
    <button class="common-button__text"
      (click)="print()">
      <span class="common-button__text-title"
        [afTranslate]="'common.print'">_Imprimir</span>
    </button>
  </div>
</div>
